import { hostingPaths } from './paths';

// Plain data: no console, no loader (the entry chunk reads it; route.ts stays lazy).
/** Provider scopes this module serves in the service catalog. */
export const serviceScopes = [
  // Hosting is tenant-implicit (one hosting account per organization): no id in the URL.
  { scope: 'External.Hosting', category: 'compute', route: () => hostingPaths.base },
] as const;
